module.exports = __webpack_public_path__ + "img/200622_Ergo_Munich_Logo.697e3c05.svg";